import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit,
    Optional,
    ViewEncapsulation
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { tap } from 'rxjs/operators';
import { RepaymentScheduleRow } from 'src/app/_shared/classes/settlements/shared-repayment-schedule';
import { ScheduleService } from 'src/app/_shared/services/accounting/schedule.service';
import { EcheancierModelDtoInput } from 'src/graphql/generated-types';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { SharedEditRepaymentSchedule } from 'src/app/_shared/components/settlements/shared-edit-repayment-schedule/shared-edit-repayment-schedule.component';

export type SharedEditRepaymentScheduleDialogData = SharedEditRepaymentSchedule & { accepted?: boolean };

@Component({
    selector: 'app-shared-edit-repayment-schedule-dialog',
    templateUrl: './shared-edit-repayment-schedule-dialog.component.html',
    styleUrls: ['./shared-edit-repayment-schedule-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedEditRepaymentScheduleDialogComponent extends BaseComponent implements OnInit, OnDestroy {

    repaymentScheduleControl: FormControl;

    constructor(
        private readonly scheduleService: ScheduleService,
        protected readonly cdr: ChangeDetectorRef,
        @Optional() private readonly dialogRef: KalDialogRef<SharedEditRepaymentScheduleDialogComponent>,
        @Optional() @Inject(KAL_DIALOG_DATA) public data: SharedEditRepaymentScheduleDialogData,
    ) {
        super(cdr);
    }

    get isUpdate(): boolean {
        return this.data.editionMode === 'update';
    }

    cancel(): void {
        this.dialogRef.close({accepted: false});
    }

    submit(): void {
        if (!this.repaymentScheduleControl) {
            return;
        }

        this.data.repaymentSchedule = this.repaymentScheduleControl.value;
        this.data.title = this.data.repaymentSchedule.label;
        if (!this.isUpdate) { // creation
            this.data.accepted = true;
            this.dialogRef.close(this.data);
        } else { // modification
            const schedulesList: RepaymentScheduleRow[] = this.data.repaymentSchedule.schedule.map(res => ({
                    LibelleEcheance: res.LibelleEcheance,
                    DateEcheance: res.DateEcheance,
                    MontantEcheance: res.MontantEcheance,
                    NumeroCheque: res.NumeroCheque,
                    NomBanque: res.NomBanque,
                    NomTire: res.NomTire,
                    IsRemisEnBanque: res.IsRemisEnBanque
                }
            ));

            const {
                label: LibelleEcheancier,
                paymentDayOfMonth: JourEcheance,
                paymentFrequency: Frequence,
                numberOfDueDate: NbEcheance
            } = this.data.repaymentSchedule;

            const newSchedule: EcheancierModelDtoInput = {
                Id: this.data.Id,
                IdBenef: this.data.IdBenef,
                IdMoyenPaiement: this.data.paymentMethod.Id,
                IdRib: this.data.repaymentSchedule?.ibanId || this.data.IdRib,
                IdCompteBancaire: this.data.IdCompteBancaire,
                LibelleEcheancier,
                JourEcheance,
                Frequence,
                NbEcheance,
                ListeEcheances: {
                    EcheanceModelDTO: schedulesList
                }
            };

            // on vérifie si il y a des écritures lettrées
            this.watch$ = this.wrapLoader$(this.scheduleService.createRepaymentSchedule$(newSchedule)).pipe(
                tap(() => this.dialogRef.close({accepted: true}))
            );
        }
    }

    ngOnInit(): void {
        this.repaymentScheduleControl = new FormControl(null);
    }
}
